import React from 'react';
import { PageLayout, PageCard, FormContainer } from './BaseComponents.jsx';
import Theme from '../../styles/theme.js';
import Loader from '../Loader.jsx';

// Standard screen template that most screens can use
export const StandardScreen = ({
  title,
  description,
  loading,
  loadingLabel,
  children,
  cardProps = {}
}) => (
  <div style={{
    minWidth: Theme.layout.cardMinWidth,
    maxWidth: Theme.layout.cardMaxWidth,
    width: Theme.layout.cardWidth
  }}>
    <PageCard
      title={
        <span style={{
          fontWeight: Theme.typography.fontWeight.medium,
          fontSize: Theme.typography.fontSize.xlarge
        }}>
          {title}
        </span>
      }
      description={
        <span style={{

          fontSize: Theme.typography.fontSize.medium,
          color: Theme.colors.primary,
        }}>
          {description}
        </span>
      }
      {...cardProps}
    >
      {loading ? <Loader label={loadingLabel} /> : (
        <FormContainer>
          {children}
        </FormContainer>
      )}
    </PageCard>
  </div>
);
